// angular
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// types & constants
import { IPages, ISocialMedia } from '@app/shared/types/footer-menu.type';
import {
  footerPages1,
  footerPages2,
  footerSocialMedias,
} from '@app/shared/constants/footer-data.const';

@Component({
  selector: 'pwj-footer',
  standalone: true,
  imports: [RouterLink, CommonModule, NgOptimizedImage, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  public pages1: IPages[] = footerPages1;
  public pages2: IPages[] = footerPages2;
  public socialMedias: ISocialMedia[] = footerSocialMedias;

  public fullYear = new Date().getFullYear();
  public hoveredSocialMediaId!: number | null;

  constructor() {}

  public onIconHover(socialId: number) {
    this.hoveredSocialMediaId = socialId;
  }

  public onIconHoverFinish() {
    this.hoveredSocialMediaId = null;
  }
}
